module.exports = __webpack_public_path__ + "static/img/186_TO8_2054_og.f72a00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/186_TO8_2054_og.jpg
// module id = Ctg6
// module chunks = 0